@if (state === 'loading') {
  <app-spinner></app-spinner>
}
@if (state === 'ready') {
  <mat-menu #filterMenu>
    <a mat-menu-item routerLink="/shows/all">All</a>
    <a mat-menu-item routerLink="/shows/all/episodes">Episodes</a>
    <a mat-menu-item routerLink="/shows/all/clips">Clips</a>
    <a mat-menu-item routerLink="/shows/all/podcasts">Podcasts</a>
  </mat-menu>
  <button mat-button [matMenuTriggerFor]="filterMenu" class="filter">
    <mat-icon>filter_list</mat-icon>
    @if (requestedSection === 'content') {
      All
    }
    @if (requestedSection === 'episodes') {
      Episodes
    }
    @if (requestedSection === 'clips') {
      Clips
    }
    @if (requestedSection === 'podcasts') {
      Podcasts
    }
  </button>
  @for (episode of productions; track episode; let i = $index) {
    @if (hasItemsOfRequestedType(episode)) {
      <div class="production">
        @if (mode === 'content') {
          <tyt-production-view
            [production]="episode"
            [showFeedTag]="false"
            [showDate]="false"
            [includeItems]="false"
            [style.animation-delay]="(i * 100)+'ms'">
          </tyt-production-view>
          <mat-tab-group mat-stretch-tabs="false" class="production-content">
            @if (episode.full_length_vods.length > 0) {
              <mat-tab label="Episode" labelClass="episodes">
                <tyt-production-view
                  [production]="episode"
                  mode="episodes"
                  [includeMetadata]="false"
                  [showFeedTag]="false"
                  [showDate]="false"
                  [style.animation-delay]="(i * 100)+'ms'"
                ></tyt-production-view>
              </mat-tab>
            }
            @if (episode.vod_clips.length > 0) {
              <mat-tab label="Clips" labelClass="clips">
                <tyt-production-view
                  [production]="episode"
                  mode="clips"
                  [includeMetadata]="false"
                  [showFeedTag]="false"
                  [showDate]="false"
                  [style.animation-delay]="(i * 100)+'ms'"
                ></tyt-production-view>
              </mat-tab>
            }
            @if (episode.full_length_podcasts.length > 0) {
              <mat-tab label="Podcast" labelClass="podcasts">
                <tyt-production-view
                  [production]="episode"
                  mode="podcasts"
                  [includeMetadata]="false"
                  [showFeedTag]="false"
                  [showDate]="false"
                  [style.animation-delay]="(i * 100)+'ms'"
                ></tyt-production-view>
              </mat-tab>
            }
          </mat-tab-group>
        } @else {
          <tyt-production-view
            [production]="episode"
            [mode]="mode"
            [showFeedTag]="false"
            [showDate]="false"
            [style.animation-delay]="(i * 100)+'ms'">
          </tyt-production-view>}
      </div>
    }
  }
  <tyt-pager [total]="total" [page]="page"
    [size]="pageSize"
    (changePage)="goToPage($event)"
  ></tyt-pager>
}